"use client";

import { HmcNavBar } from "@adi-ctx/harmonic-core-components-react";
import { Logo } from "@/components";
import t from "@/utils/translate.utils";
import HeaderUser from "./components/HeaderUser/HeaderUser";
import { AppProgressBar as ProgressBar } from "next-nprogress-bar";

/**
 * Header UI component for the CMS
 * @constructor
 */
export default function Header() {
	return (
		<>
			<ProgressBar
				shallowRouting
				height="2px"
				color="#98bdf0"
				options={{ showSpinner: false }}
			/>

			<header data-testid="cms-header">
				<HmcNavBar
					aria-label={t("header.nav-aria-label")}
					data-testid="cms-header-nav"
				>
					<div slot="logo" className="py-2">
						<Logo placement="header" data-testid="cms-header-nav-logo" />
					</div>

					<div slot="right-actions" className="flex gap-3 pr-2">
						<div className="flex items-center gap-1">
							<HeaderUser />
						</div>
					</div>
				</HmcNavBar>
			</header>
		</>
	);
}
